// extracted by mini-css-extract-plugin
export default {"mainContainer":"PageNotFound_mainContainer__k2Z9R","mainText":"PageNotFound_mainText__rRQZ1","muted":"PageNotFound_muted__pe6il","link":"PageNotFound_link__BR9tR"};